





























import { Vue, Component } from 'vue-property-decorator'
import { $auth } from '@/services/Auth'
import { User } from '@/types'

import AddUserForm from './AddUserForm.vue'

@Component({ components: { AddUserForm } })
export default class UsersPage extends Vue {

	loading = false
	error = ''

	users: User[] = []

	adding = false
	deleteId = ''

	get currentUserId() {
		return $auth.user.username
	}

	add(user: User) {
		this.users.push(user)
		this.adding = false
	}

	startDelete(id: string) {
		this.deleteId = id;
		(this.$refs.deleteModal as any).show()
	}
	
	runDelete() {
		$auth.deleteUser(this.deleteId)
			.then(() => {
				this.users.splice(this.users.findIndex(u => u.name === this.deleteId), 1)
				this.users = [...this.users]
				this.deleteId = ''
			})
			.catch(err => {
				alert(err.message)
			})
	}

	created() {
		this.loading = true
		$auth.listUsers()
			.then(users => this.users = users)
			.catch(err => this.error = err.message)
			.finally(() => this.loading = false)
	}

}
